var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('st-button',{attrs:{"variant":"secondary","callback":_vm.add}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$t('URBANISM_REGULATION_ZONES.ADD_BUTTON'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }